import {ModalBody, ModalHeader} from '_core/components/Modal'
import React from 'react'
import {Modal} from 'react-bootstrap'
import ViewOrderItems from '../../view/ViewOrderItems'
import SummaryItem from '../SummaryItem'

interface Props {
  onClose: () => void
  show: boolean
  summary: any
  title: string
  refundItems: any[]
  newItems: any[]
  updatedItems: any[]
}
export const HistoryDialog: React.FC<Props> = ({
  onClose,
  show,
  title,
  refundItems,
  summary,
  newItems,
  updatedItems,
}) => {
  const price = parseFloat(summary.orderEditTotal) - parseFloat(summary.orderTotal)

  return (
    <Modal
      size='lg'
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='h-auto'
      show={show}
      centered
    >
      <ModalHeader
        title={`${title}`}
        toolbar={{
          onClick: onClose,
        }}
      />
      <ModalBody>
        {newItems.length > 0 && <ViewOrderItems items={newItems} title='Newly Added Items' />}
        {updatedItems.length > 0 && <ViewOrderItems items={updatedItems} title='Updated Items' />}
        {refundItems.length > 0 && <ViewOrderItems items={refundItems} title='Refunded Items' />}

        {parseFloat(summary.orderEditSubTotal) !== parseFloat(summary.orderSubTotal) && (
          <>
            <SummaryItem title='Prev Order Subtotal' value={summary.orderSubTotal} isValueBolder />
            <SummaryItem title='Subtotal' value={summary.orderEditSubTotal} isValueBolder />
            <hr />
          </>
        )}

        {parseFloat(summary.orderShippingPrice) !== parseFloat(summary.orderEditShippingPrice) && (
          <>
            <SummaryItem
              title='Prev Order Shipping Price'
              value={summary.orderShippingPrice}
              isValueBolder
            />

            <SummaryItem
              title='Shipping Price'
              value={summary.orderEditShippingPrice}
              isValueBolder
            />
            <hr />
          </>
        )}

        {parseFloat(summary.orderEditWineClubDiscounts) !==
          parseFloat(summary.orderWineClubDiscounts) && (
          <>
            <SummaryItem
              title='Prev Order Total WineClub Discounts'
              value={summary.orderWineClubDiscounts}
              isValueBolder
            />
            <SummaryItem
              title='Total WineClub Discounts'
              value={summary.orderEditWineClubDiscounts}
              isValueBolder
            />
            <hr />
          </>
        )}

        {parseFloat(summary.orderEditTotalDiscounts) !==
          parseFloat(summary.orderTotalDiscounts) && (
          <>
            <SummaryItem
              title='Prev Order Total Discounts'
              value={summary.orderTotalDiscounts}
              isValueBolder
            />
            <SummaryItem
              title='Total Discounts'
              value={summary.orderEditTotalDiscounts}
              isValueBolder
            />
            <hr />
          </>
        )}

        {parseFloat(summary.orderEditTax) !== parseFloat(summary.orderTax) && (
          <>
            <SummaryItem title='Prev Order Total Tax' value={summary.orderTax} isValueBolder />
            <SummaryItem title='Total Tax' value={summary.orderEditTax} isValueBolder />
            <hr />
          </>
        )}

        <SummaryItem title='Prev Order Total Price' value={summary.orderTotal} isValueBolder />
        <SummaryItem title='Total Price' value={summary.orderEditTotal} isValueBolder />
        <hr />
        {price === 0 ? null : (
          <>
            {price > 0 ? (
              <SummaryItem title='Additional Amount Charged' value={price} isValueBolder />
            ) : (
              <SummaryItem title='Amount Refunded' value={price * -1} isValueBolder />
            )}
            <hr />
          </>
        )}
      </ModalBody>
    </Modal>
  )
}

export default HistoryDialog
